import React from 'react';
import { ROUTE_SIGNUP, ROUTE_SIGNIN } from '../../../constants/routeconstants';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { NotificationManager } from 'react-notifications';
import ProfileForm from '../../reusable/profile/ProfileForm';
import * as UserActions from '../../../actions/user';

class SignUpPage extends React.Component {

    static getId() {
        return ROUTE_SIGNUP;
    }

    static getAllowedRoles() {
        return []; // empty means allowed for all
    }

    render() {
        return (
            <div className="signup-page">
                <div className="sub-page-title">
                    <h1>Create profile</h1>
                </div>
                <div className="sub-page-content">
                    <ProfileForm profile={null} onSubmit={this.handleSubmit} submitButtonText="Register" params={this.props.location.query} />
                </div>
            </div>
        );
    }

    handleSubmit = userProfile => {
        if (this.props.user.isSaving) return;
        const onSuccess = () => NotificationManager.success("Thanks for registering.", "Registration completed", 4000);
        this.props.dispatch(UserActions.userCreate(userProfile, onSuccess));
    };
}

const mapStateToProps = (state) => ({
    user: state.user,
});

export default connect(mapStateToProps)(SignUpPage);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/signup/SignUpPage.js